var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading_box",style:(_vm.style)},[_c('div',{staticClass:"loading"}),_c('div',{staticClass:"loading_text"},[_vm._v("loading")])])}
var staticRenderFns = []

export { render, staticRenderFns }